import { Table, TableRow, TableCell, TableBody } from '@bosch/react-frok'
import './SkeletonLoading.scss'

interface ChatHistorySkeletonProps {
    isMobile?: boolean
    itemCount?: number
}

const ChatHistorySkeleton: React.FC<ChatHistorySkeletonProps> = ({ isMobile = false, itemCount = 3 }) => {
    return (
        <div className="mma-skeleton-loader">
            <div className="chat-history">
                <div className='title-last-chats-wrapper'>
                    <div className='skeleton-title'></div>
                </div>
                <Table>
                    <TableBody>
                        {Array.from({ length: itemCount }).map((_, index) => (
                            <TableRow key={index} className='chat-history-row skeleton-row'>
                                {isMobile ? (
                                    <TableCell className='mobile-chat-cell'>
                                        <div className='mobile-chat-label-group'>
                                            <div className='skeleton-icon'></div>
                                            <div className='mobile-chat-label'>
                                                <div className='skeleton-text skeleton-label'></div>
                                                <div className='skeleton-text skeleton-timestamp'></div>
                                            </div>
                                        </div>
                                        <div className='mobile-chat-actions'>
                                            <div className='skeleton-icon-small'></div>
                                        </div>
                                    </TableCell>
                                ) : (
                                    <>
                                        <TableCell className='desktop-cell desktop-label-cell'>
                                            <div className='chat-label-group'>
                                                <div className='skeleton-icon'></div>
                                                <div className='skeleton-text skeleton-label'></div>
                                            </div>
                                        </TableCell>
                                        <TableCell className='desktop-cell desktop-timestamp-cell'>
                                            <div className='skeleton-text skeleton-timestamp'></div>
                                        </TableCell>
                                        <TableCell className='desktop-cell desktop-actions-cell'>
                                            <div className='skeleton-icon-small'></div>
                                        </TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    )
}

export default ChatHistorySkeleton
